import { HttpParams } from '@angular/common/http';

export const MapObjectToHttpParams = (
    searchParams: { [key: string]: any },
    convertLowerCamelCase = false
): HttpParams => {
    let httpParams: HttpParams = new HttpParams();

    Object.keys(searchParams).forEach(key => {
        const value: any = searchParams[key];

        if (value === undefined || value === null) {
            return;
        }

        const httpParamKey = convertLowerCamelCase ? upperToLowerCamelCase(key) : key;

        if (Array.isArray(value)) {
            httpParams = value.reduce((params: HttpParams, item: any) => params.append(httpParamKey, item), httpParams);
        } else {
            httpParams = httpParams.set(httpParamKey, value);
        }
    });

    return httpParams;
};

function upperToLowerCamelCase(str: string): string {
    if (!str || str.length === 0) {
        return str;
    }

    // Convert first character to lowercase, keep the rest unchanged
    return str.charAt(0).toLowerCase() + str.slice(1);
}
